
// 角色权限弹框
import React, { Component } from 'react';
import {message, Modal, Tree, Spin } from 'antd';
import '../../../static/css/index.css'
import { getRoleMenu, getRoleMenuChild, updateRoleMenu } from '../../../apis/api'
import '../index.css'

const TreeNode = Tree.TreeNode;

class RolePrivilege extends Component {
  constructor(props) {
    super(props);
    this.state={
        access_token:'',
        loading:false,
        treeData:[],//角色权限列表
        expandedKeys: [],//（受控）展开指定的树节点
        checkedKeys: [],//选中复选框的树节点
    }
  }

  componentDidMount(){
    this.setState({access_token:sessionStorage.getItem('access_token')},()=>{
        if(this.props.role_uuid){
            this.getRoleMenu(this.props.role_uuid);
        }

    })
    
  }

  
  componentWillReceiveProps(nextProps) { 
      if(nextProps.visible){
        if(nextProps.role_uuid&&nextProps.role_uuid!==this.props.role_uuid){
            this.setState({treeData:[],expandedKeys:[],checkedKeys:[],autoExpandParent:true},()=>{
                this.getRoleMenu(nextProps.role_uuid);
            })
        }
      }
     
  }

  getRoleMenu(role_uuid){
    let _this=this;
    this.setState({loading:true})
    const { access_token } = this.state;
    let params={
        access_token:access_token,
        role_uuid:role_uuid?role_uuid:_this.props.role_uuid,
    }
    getRoleMenu(params).then( (data)=> {

        if(data.code === 0){

            let treeData=data.content;
            let checkedKeys=[],expandedKeys=[];
            treeData.length&&treeData.map(item=>{
                if(item.has_permission===1){
                    checkedKeys.push(item.uuid);
                    if(item.has_child===1){
                        expandedKeys.push(item.uuid)
                    }
                }
                return item;
            })
            _this.setState({ treeData, loading:false, checkedKeys, expandedKeys })

        }else{

            message.error(data.message); 
        }
    });

  }

  //展开/收起节点树形控件时触发
  onExpand = (expandedKeys) => {
    this.setState({
      expandedKeys
    });
  }

  //点击复选框触发e:{checked: bool, checkedNodes, node, event}
  onCheck = (checkedKeys,e) => {
    // console.log('已选中的值',checkedKeys.checked)
    // console.log('选中还是取消---true为选择false为取消选择',e.checked)
    // console.log('当前选择的值',e.node.props.eventKey)
    let type,_this=this;
    if(e.checked==true){
        type=1;
      }else{
        type=2;
      }
    this.setState({ checkedKeys:checkedKeys.checked },()=>{
        updateRoleMenu({
            access_token:_this.state.access_token,
            menu_uuid:e.node.props.eventKey,
            role_uuid:_this.props.role_uuid,
            type:type
        }).then(function(data) {

           if (data.code === 0) {
              if(type==1){
                message.success("添加角色权限成功！");
              }else{
                message.success("删除角色权限成功！");
              }
           }else{
              message.error(data.message);
           }
        })
    });
  }

    onLoadData = TreeNode =>{
        let _this=this;
        return new Promise(resolve => {
          if (TreeNode.props.child) {
            resolve();
            return;
          }
          getRoleMenuChild({
            access_token:_this.state.access_token,
            role_uuid:_this.props.role_uuid,
            menu_uuid:TreeNode.props.dataRef.uuid
          }).then(function(data) {
           if (data.code === 0) {
            let checkedKeys=_this.state.checkedKeys;
            // let expandedKeys=_this.state.expandedKeys;
            data.content.length&&data.content.map(item=>{
                if(item.has_permission===1){
                    checkedKeys.push(item.uuid);
                    // if(item.has_child===1){
                    //     expandedKeys.push(item.uuid)
                    // }
                }
            })
            TreeNode.props.dataRef.child=data.content;
             _this.setState({
              treeData: [..._this.state.treeData],
              checkedKeys,
            //   expandedKeys
             });
             resolve();
           }else {
             message.error(data.message);
           }
         })
        });
        }

renderTreeNodes = data =>
    data&&data.length&&data.map(item => {
      if (item.child) {
        return (
          <TreeNode className={item.type===3?'child':''} isLeaf={item.has_child===2} title={item.name} key={item.uuid} dataRef={item}>
            {this.renderTreeNodes(item.child)}
          </TreeNode>
        );
      }
      return <TreeNode className={item.type===3?'child':''} isLeaf={item.has_child===2} title={item.name} key={item.uuid} {...item} dataRef={item} />;
    });



  // 点击确定、取消按钮
  handleOk = (e) => {
    this.props.cancelModal();
  }

  render() {
   
    let _this=this;
    const { visible } = this.props;
    const { loading, treeData, expandedKeys, checkedKeys } = this.state;

    return (

       <div className='role_privilege_form'>

        <Modal
          title="角色权限"
          visible={visible}
          footer={null}
        //   onOk={this.handleOk}
          onCancel={this.handleOk}
          okText="确定"
          cancelText="取消"
          width='50%'
        >
        <div className='role_privilege'>
        <Spin spinning={loading}>
            <Tree
               checkable
               onExpand={this.onExpand}
               expandedKeys={expandedKeys}
               onCheck={this.onCheck}
               checkedKeys={checkedKeys}
               checkStrictly
               loadData={this.onLoadData}
            >
                {this.renderTreeNodes(treeData)}
            </Tree>
        </Spin>
        </div>
    
      </Modal>

    </div>
    );
  }
}

export default RolePrivilege;



// WEBPACK FOOTER //
// ./src/page/Privilege/components/rolePrivilege.js